import "./TaskTypePill.scss";

import { useSelector } from "utils/redux";

type TaskTypeCornerPillProps = {
  taskType: string;
  className?: string;
};

// color mapping for different task types
const TASK_TYPE_COLORS: Record<string, string> = {
  OF: "blue", // Open File
  CF: "green", // Complete File
  G: "purple", // Generic
  CS: "orange", // Complete Service
  CR: "red", // CMS Response
  MSADCD: "pink", // MSA Decision Client Disclosure
  MSADDU: "yellow", // MSA Development Document Upload
  MSADDA: "brown", // MSA Development Document Analysis
  MSADN: "blue", // MSA Development Client Notification
  MSADA: "green", // MSA Development Analysis Disclosure
  MSADNAT: "purple", // MSA Development Client Notification Attorney Intervention
  MSADAT: "orange", // MSA Development Analysis Disclosure Attorney Intervention
  FCU: "red", // Query Coverage Updates
};

const TASK_TYPE_LABEL_COLORS: Record<string, string> = {
  "CMS Submission Prep": "purple",
  "CMS Submission Review": "orange",
  "Sort & Summarization": "blue",
};

// abbreviated labels for task types that are too long for the pill
const TASK_TYPE_ABBREVIATIONS: Record<string, string> = {
  MSADCD: "MSA Decision",
  MSADDU: "MSA Doc Upload",
  MSADDA: "MSA Doc Analysis",
  MSADN: "MSA Client Notice",
  MSADA: "MSA Analysis",
  MSADNAT: "MSA Client Notice (Atty)",
  MSADAT: "MSA Analysis (Atty)",
  G: "Misc",
};

const TASK_TYPE_LABEL_ABBREVIATIONS: Record<string, string> = {
  "CMS Submission Prep": "CMS Prep",
  "CMS Submission Review": "CMS Review",
  "Sort & Summarization": "Sort & Summary",
};

export const TaskTypeCornerPill = ({
  taskType,
  className = "",
}: TaskTypeCornerPillProps) => {
  const constants = useSelector((state) => state.shared.constants);

  // find the task type label from constants
  const taskTypeOption = constants?.TaskType?.find(
    (option) => option.value === taskType,
  );

  const taskTypeLabel = taskTypeOption?.label;

  // use abbreviated label if available, otherwise fall back to constants or task type code
  const label =
    TASK_TYPE_ABBREVIATIONS[taskType] ||
    (taskTypeLabel && TASK_TYPE_LABEL_ABBREVIATIONS[taskTypeLabel]) ||
    taskTypeLabel ||
    taskType;
  const colorClass =
    TASK_TYPE_COLORS[taskType] ||
    (taskTypeLabel && TASK_TYPE_LABEL_COLORS[taskTypeLabel]) ||
    "grey";

  return (
    <div className={`task-type-corner-pill ${className}`}>
      <span className={colorClass}>{label}</span>
    </div>
  );
};

export default TaskTypeCornerPill;
